import { useMutation } from '@tanstack/react-query'
import { createPortfolio } from 'services/RewardsService'
import { CreateRewardsPortfolioRequest, Portfolio } from 'types/rewards'

export const useCreatePortfolioMutation = () =>
  useMutation<Portfolio, Error, CreateRewardsPortfolioRequest>({ mutationFn: createPortfolio })
